"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateClientData = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const tools_1 = require("../tools");
const types_1 = require("../types");
const generateClientData = (client = {}) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return {
        id: (_a = client.id) !== null && _a !== void 0 ? _a : (0, tools_1.IDSource)(),
        name: (_b = client.name) !== null && _b !== void 0 ? _b : en_1.faker.company.name(),
        description: (_c = client.description) !== null && _c !== void 0 ? _c : en_1.faker.lorem.words(20),
        language: (_d = client.language) !== null && _d !== void 0 ? _d : types_1.LANGUAGE.en,
        app_user_licenses: (_e = client.app_user_licenses) !== null && _e !== void 0 ? _e : en_1.faker.number.int(20),
        max_downloads: (_f = client.max_downloads) !== null && _f !== void 0 ? _f : 10,
        downloads_count: (_g = client.downloads_count) !== null && _g !== void 0 ? _g : 0,
        downloads_quota_period: "",
        active: (_h = client.active) !== null && _h !== void 0 ? _h : true,
        dbname: (_j = client.dbname) !== null && _j !== void 0 ? _j : en_1.faker.person.firstName().toLowerCase(),
        logo: (_k = client.logo) !== null && _k !== void 0 ? _k : en_1.faker.image.url(),
        time_slots_start: (_l = client.time_slots_start) !== null && _l !== void 0 ? _l : new Date(),
        time_slots_stop: (_m = client.time_slots_stop) !== null && _m !== void 0 ? _m : new Date(),
        capacity_quota: (_o = client.capacity_quota) !== null && _o !== void 0 ? _o : 10000,
        capacity_used: (_p = client.capacity_used) !== null && _p !== void 0 ? _p : 1,
    };
};
exports.generateClientData = generateClientData;
